export enum MAIN_COLOR {
	BLACK = "black",
	GREEN = "green",
	ORANGE = "orange",
	PINK = "pink",
}
